<template>
    <div class="login">
        <div class="colum" :style="{'width': '60%'}">
            <div class="login_container">
                <img src="@/assets/logo/logo.webp" alt="" class="a">
                <img src="@/assets/logo-aser.png" alt="" class="b">
                <center>
                    <div v-if="errorMessage != null" class="error">{{errorMessage}}</div>
                    <h3>LOGIN ADMIN</h3>
                    <label for="">Usuario</label>
                    <input type="text" v-model="email">
                    <label for="">Contraseña</label>
                    <input type="password" v-model="password" name="" id="">
                    <input type="submit" @click="login" value="Ingresar" class="send">
                </center>
            </div>
        </div>
    </div>
</template>

<script>
import API from '../api/index'

export default {
    name: 'Login',
    data() {
        return {
            email: null,
            password: null,
            errorMessage: null
        }
    },
    methods: {
        login: function(e) {
            e.preventDefault()
            API.Login(this.email, this.password)
                .then((response) => {
                    if (response[0].res !== 'ok') {
                        this.errorMessage = 'Sus credenciales de inicio son incorrectas, si necesita ayuda comuníquese con soporte'
                        return false
                    }
                    this.$router.push('/add-blog')
                })
        }
    }
}
</script>

<style scoped>
    .login {
        background-image: url('../assets/servicios-bg-empresariales.png');
        background-position: center;
        background-attachment: fixed;
        background-size: auto 100%;
        width: 100%;
        height: 100vh;
        display: flex;
    }
    .container {
        width: 100%;
        height: 100vh;
        display: table;
    }
    .login_container {
        background-color: #fff;
        -webkit-box-shadow: 5px 5px 15px 5px #000000;
        box-shadow: 5px 5px 15px 5px #000000;
        width: 500px;
        color: #000000;
        height: 500px;
        position: absolute;
        top: 50%;
        left: 50%;
        margin: auto;
        transform: translate(-50%, -50%);
    }
    .login_container > center {
        padding: 20px;
        position: absolute;
        top: 0;
        right: 0;
        left: 0;
        bottom: 0;
        margin: auto;
        width: 100%;
        height: 250px;
    }
    .login_container  > img {
        width: 200px;
    }
    .login_container  > img.a {
        margin-top: 30px;
        width: 200px;
        float: left;
        margin-left: 30px;
    }
    .login_container  > img.b {
        margin-top: 60px;
        width: 200px;
        float: right;
        margin-right: 30px;
    }
    .login_container > center > h3 {
        color: #000;
    }
    .login_container > center > label {
        color: #000;
        width: 100%;
        font-size: 22px;
    }
    .login_container > center > input[type=text], input[type=password] {
        text-align: center;
        border-radius: 20px;
        height: 40px;
        width: 300px;
    }
    .login_container > center > input[type=submit] {
        width: 200px;
        height: 40px;
        border-radius: 20px;
        text-align: center;
        margin-top: 20px;
        color: #fff;
        font-size: 22;
        background-color: #65b24a;
    }
    .error {
        color:red;
        font-family: 'JR';
    }
</style>



// WEBPACK FOOTER //
// src/components/adminLogin.vue